'use client';
import React from 'react';
import { Collapse } from 'antd';
import { useTranslations } from 'next-intl';
import { Link } from '@/intl/navigation';
import AfiwaTag from '@/ui/shared/components/afiwaTag';
import SectionHeading from '@/ui/shared/components/sectionHeading';
import { MinusIcon, PlusIcon } from '@heroicons/react/20/solid';
import Image from 'next/image';
import backgroundImage from './propagate.png';
import { afiwaSocials } from '@/constants/contacts';

function FaqQuestions() {
  const faqText = useTranslations('tutorials.faq');

  return (
    <div className="my-20 flex flex-col gap-y-16 md:my-32 md:gap-y-32">
      <div className="relative mx-auto flex flex-col items-center justify-center gap-y-5 text-center md:gap-y-10">
        <div className="mx-auto flex w-44 items-center justify-center  text-sm ">
          <AfiwaTag text={faqText('faq')} />
        </div>
        <SectionHeading className="flex flex-row gap-x-1 font-extrabold">
          <span className="text-primary-dark">
            {faqText('frequently_asked')}
          </span>
          <span className="text-primary">{faqText('questions')}</span>
        </SectionHeading>

        <p className="text-xs text-primary-pale md:text-sm ">
          {faqText('got_questions')}
        </p>

        {/* bg-image */}
        <Image
          fill
          src={backgroundImage}
          alt="bg-img"
          style={{ objectFit: 'cover' }}
          className={'!-top-[70px] w-[100%]'}
        />
      </div>

      <div className="space-y-4">
        <div className="faq-collapse-wrapper">
          <Collapse
            bordered={false}
            className=" !space-y-5"
            accordion
            items={FaqQuestionsList()}
            expandIconPosition="start"
            expandIcon={({ isActive }) =>
              isActive ? (
                <MinusIcon className="h-3 w-3 text-blue-500" /> // Minus when open
              ) : (
                <PlusIcon className="h-3 w-3 text-blue-500" /> // Plus when closed
              )
            }
          />
        </div>
      </div>
    </div>
  );
}

export default FaqQuestions;

function FaqQuestionsList() {
  const t = useTranslations('howitworks');
  const text = useTranslations('inApp');
  const contactSupportLink = text('contactSupport');

  const questAns = [
    { quest: t('faq.quest_1'), ans: t('faq.ans_1') },
    {
      quest: t('faq.quest_2'),
      ans: t('faq.ans_2'),
      link: contactSupportLink,
    },
    {
      quest: t('faq.quest_3'),
      ans: t('faq.ans_3'),
      link: contactSupportLink,
    },
    {
      quest: t('faq.quest_4'),
      ans: t('faq.ans_4'),
      link: contactSupportLink,
    },
    { quest: t('faq.quest_5'), ans: t('faq.ans_5') },
    { quest: t('faq.quest_6'), ans: t('faq.ans_6') },
    { quest: t('faq.quest_7'), ans: t('faq.ans_7') },
    { quest: t('faq.quest_8'), ans: t('faq.ans_8') },
    { quest: t('faq.quest_9'), ans: t('faq.ans_9') },
    { quest: t('faq.quest_10'), ans: t('faq.ans_10') },
    { quest: t('faq.quest_11'), ans: t('faq.ans_11') },
    { quest: t('faq.quest_12'), ans: t('faq.ans_12') },
    { quest: t('faq.quest_13'), ans: t('faq.ans_13') },
    { quest: t('faq.quest_14'), ans: t('faq.ans_14') },
    { quest: t('faq.quest_15'), ans: t('faq.ans_15') },
    { quest: t('faq.quest_16'), ans: t('faq.ans_16') },
    {
      quest: t('faq.quest_17'),
      ans: t('faq.ans_17'),
      link: contactSupportLink,
    },
    { quest: t('faq.quest_18'), ans: t('faq.ans_18') },
    { quest: t('faq.quest_19'), ans: t('faq.ans_19') },
  ];

  return questAns.map((item, index) => ({
    key: index,
    label: (
      <h5 className="text-sm font-semibold text-primary-dark">{item.quest}</h5>
    ),
    children: (
      <p className="text-sm text-primary-pale">
        {item.ans}
        {item.link && (
          <span>
            <Link
              href={afiwaSocials.whatsapp.link}
              target="_blank"
              className="ms-1 text-orange-200 underline"
            >
              {text('contactSupport')}
            </Link>
          </span>
        )}
      </p>
    ),
  }));
}
